<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      top="2vh"
      width="1200px"
      :title="$l('title_append_booking') || '追加订舱'"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
      append-to-body
      v-el-dialog-drag
    >
      <Main
        ref="main"
        :shipmentCode="shipmentCode"
        :shipmentContainerCode="shipmentContainerCode"
        @close="close"
        @reload="$emit('reload')"
      />

      <span slot="footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.save()">
          {{ $l('btn_confirm_save') || '确认保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'

export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
    shipmentContainerCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
